__turbopack_context__.v({
  "backButton": "_7odaIa_backButton",
  "body": "_7odaIa_body",
  "closeButton": "_7odaIa_closeButton",
  "container": "_7odaIa_container",
  "content": "_7odaIa_content",
  "contentPlain": "_7odaIa_contentPlain",
  "disclaimer": "_7odaIa_disclaimer",
  "footer": "_7odaIa_footer",
  "footerActions": "_7odaIa_footerActions",
  "head": "_7odaIa_head",
  "headIdentity": "_7odaIa_headIdentity",
  "mobileOverlay": "_7odaIa_mobileOverlay",
  "modal": "_7odaIa_modal",
  "sourceLink": "_7odaIa_sourceLink",
  "sources": "_7odaIa_sources",
  "sourcesLabel": "_7odaIa_sourcesLabel",
  "title": "_7odaIa_title",
});
